import { AdBanner } from '@techminds/ad-banner';
import classNames from 'classnames/bind';
import { useState } from 'react';
import styles from './index.module.scss';

export const INLINE_BANNER_INDEX = 14;

const cx = classNames.bind(styles);
const adSlotInfo = {
  adUnitId: 'tm_travel_flight_searchlist_inline_banner',
  uct: 'KR',
};

const InlineBanner = () => {
  const [isAdLoaded, setIsAdLoaded] = useState(false);
  const handleAdLoad = () => {
    setIsAdLoaded(true);
  };

  return (
    <div className={cx('InlineBanner')}>
      <AdBanner
        adSlotInfo={adSlotInfo}
        className={cx('ad_banner', isAdLoaded && 'loaded')}
        onAdLoaded={handleAdLoad}
      />
    </div>
  );
};

export default InlineBanner;
